import React from 'react';
import HeaderSmall from '../Components/Header/HeaderUnauthorized';
import Content from '../Components/Content';
import Paper from 'material-ui/Paper';
import {connect } from 'react-redux';

class Logs extends React.Component {
    render() {
        return (
            <div>
                <HeaderSmall  useBackFunction={true}>
                    <span className="white" >Logs</span>
                </HeaderSmall>
                <div className="container" >
                <br />
                    <Paper>
                        <br />
                        <div >
                            {this.props.logs.map((log) => (
                                <div>
                                {log}
                                <br />
                                <hr />
                                <br />
                                </div>
                            ))}
                        </div>
                    </Paper>
                </div>
            </div>
        );
    }
};


const mapDispatchToProps = (dispatch) => {
    return {
      logoffUser: () => {
        //dispatch(logoutUser());
      }
    }
  }
  
  const mapStateToProps = (state) => ({
    logs: state.thisApp.environment.logs
  })
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Logs)


// WEBPACK FOOTER //
// ./src/Pages/Logs.js